const currency = require('./currency-service');
const percent = require('./percent-service');
const unit = require('./unit-service');

module.exports = {
    currency,
    percent,
    unit,
};